import urlStringify from './urlStringify'


const host = `${window.location.origin}/api`;

const appId = "zt5KHiUpFQVtWyzU7QoMYjbQ";

global.host = host;

const path = window.location.pathname.split("/");
const articleId = path[2];


type Options = {
  headers?: object;
  body?: object;
  form?: boolean;
  [propName: string]: any;
}

export const request = async (url: string, options?: Options, count = 0) => {

  let _options = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Article-Id": articleId,
    }
  };
  if (options) {
    const { headers, body, form, ...rest } = options;

    if (headers) {
      Object.assign(_options.headers, headers);
    }
    if (form) {
      Object.assign(_options.headers, { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' });
      Object.assign(_options, { body: urlStringify(form) }, rest)
    } else {
      if (rest.method === 'post' || rest.method === 'POST') {
        Object.assign(_options, { body: JSON.stringify(body) }, rest);
      } else {
        url = count === 0 ? url + '?' + urlStringify(body) : url;
        Object.assign(_options, rest)
      }
    }

  }

  if (url.indexOf('http') === -1) {
    url = host + url
  }


  console.log("request ->", url, _options);

  try {
    let response = await fetch(url, {
      method: 'get',
      cache: 'default',
      credentials: 'include',
      ..._options,
    });

    let status = response.status;

    let result = await response.json();

    if (status === 401) {

    }
    if (status === 403 && count < 3) {
      await request(url, options, count + 1);

      return
    }

    return result
  } catch (e) {
    console.error("request error->", e)
  }
};

const randomString = (length: number) => {
  let text = "";
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export const jumpToOAuth2 = () => {
  let ssoEndPoint = 'https://sso.zto.com';
  if (window.location.origin !== 'https://jxadmin.zt-express.com') {
    ssoEndPoint = 'http://sso.test.ztosys.com';
  }

  location.href = `${ssoEndPoint}/oauth2/authorize?appid=${appId}&redirect_uri=` +
    `${encodeURIComponent(`${host}/oauth2/callback?redirect_uri=${encodeURIComponent(window.location.href)}`)}` +
    `&response_type=code&scope=userinfo,user_id,usercontact&state=${randomString(16)}`;
};

export const getSsoUserInfo = () => {
  let ssoEndPoint = 'https://sso.zto.com';
  if (window.location.origin !== 'https://jxadmin.zt-express.com') {
    ssoEndPoint = 'http://sso.test.ztosys.com';
  }

  return request(`${ssoEndPoint}/users/current/profile`, {
    credentials: 'include',
  });
}


// WEBPACK FOOTER //
// ./src/utils/request.ts